/**
 * Derived from https://shopify.dev/api/admin-rest/2022-10/resources/fulfillment
 */
export var ShopifyFulfillmentWebhookDataShipmentStatus;
(function (ShopifyFulfillmentWebhookDataShipmentStatus) {
    /** A label for the shipment was purchased and printed. */
    ShopifyFulfillmentWebhookDataShipmentStatus["LABEL_PRINTED"] = "label_printed";
    /** A label for the shipment was purchased, but not printed. */
    ShopifyFulfillmentWebhookDataShipmentStatus["LABEL_PURCHASED"] = "label_purchased";
    /** Delivery of the shipment was attempted, but unable to be completed. */
    ShopifyFulfillmentWebhookDataShipmentStatus["ATTEMPTED_DELIVERY"] = "attempted_delivery";
    /** The shipment is ready for pickup at a shipping depot. */
    ShopifyFulfillmentWebhookDataShipmentStatus["READY_FOR_PICKUP"] = "ready_for_pickup";
    /** The carrier is aware of the shipment, but hasn't received it yet. */
    ShopifyFulfillmentWebhookDataShipmentStatus["CONFIRMED"] = "confirmed";
    /**
     * The shipment is being transported between shipping facilities on the way
     * to its destination.
     */
    ShopifyFulfillmentWebhookDataShipmentStatus["IN_TRANSIT"] = "in_transit";
    /** The shipment is being delivered to its final destination. */
    ShopifyFulfillmentWebhookDataShipmentStatus["OUT_FOR_DELIVERY"] = "out_for_delivery";
    /** The shipment was succesfully delivered. */
    ShopifyFulfillmentWebhookDataShipmentStatus["DELIVERED"] = "delivered";
    /*
     * Something went wrong when pulling tracking information for the shipment,
     * such as the tracking number was invalid or the shipment was canceled.
     */
    ShopifyFulfillmentWebhookDataShipmentStatus["FAILURE"] = "failure";
})(ShopifyFulfillmentWebhookDataShipmentStatus || (ShopifyFulfillmentWebhookDataShipmentStatus = {}));
/**
 * @deprecated
 * Derived from https://shopify.dev/api/admin-rest/2022-10/resources/fulfillment
 *
 * The status of an order in terms of the line items being fulfilled.
 * Valid values: fulfilled, null, or partial. This field will be deprecated.
 * Use the status property on the FulfillmentOrder resource instead.
 */
export var ShopifyFulfillmentsWebhookDataLineItemFulfillmentStatus;
(function (ShopifyFulfillmentsWebhookDataLineItemFulfillmentStatus) {
    ShopifyFulfillmentsWebhookDataLineItemFulfillmentStatus["FULFILLED"] = "fulfilled";
    ShopifyFulfillmentsWebhookDataLineItemFulfillmentStatus["PARTIAL"] = "partial";
})(ShopifyFulfillmentsWebhookDataLineItemFulfillmentStatus || (ShopifyFulfillmentsWebhookDataLineItemFulfillmentStatus = {}));
//# sourceMappingURL=shopify.js.map